// components/AnmerkungenTextArea.jsx
import React from 'react';
import { TextArea } from '@progress/kendo-react-inputs';

const AnmerkungenTextArea = (fieldRenderProps) => {
  // Wenn ein "input"-Objekt vorhanden ist, verwende dessen value/onChange, ansonsten direkt die Props.
  const value = fieldRenderProps.input ? fieldRenderProps.input.value : fieldRenderProps.value;
  const onChange = fieldRenderProps.input ? fieldRenderProps.input.onChange : fieldRenderProps.onChange;
  
  return (
    <TextArea
      value={value || ""}
      onChange={(e) => {
        // Erzeuge ein synthetisches Event, damit der Form-Handler den neuen Wert übernimmt.
        onChange({ target: { value: e.value } });
      }}
      placeholder="Ihre Anmerkungen hier eintragen..."
      style={{ width: '720px', height: '150px' }}
    />
  );
};

export default React.memo(AnmerkungenTextArea);
